import styled from 'styled-components';
import Card from 'components/Card';
import { color } from 'theme';
import getColorForStatus from '../../helpers/getColorForStatus';
import { HealthScoreOverallStatus } from '../../types';
import { GREY_300, GREY_400 } from '../../../../../constants';

interface IndicatorContainerProps {
    $status?: HealthScoreOverallStatus;
}

export const IconContainer = styled.div<IndicatorContainerProps>`
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-color: ${({ $status }) => getColorForStatus($status)};
    color: white;
`;

export const HealthMetricCardContainer = styled(Card)<IndicatorContainerProps>`
    display: flex;
    flex: 1 1 280px;
    min-width: min(100%, 350px);
    gap: 0.5rem;
    align-items: center;
    padding: 1rem;
    position: relative;
    
    h3 {
        color: ${GREY_400};
        font-size: 1rem;
    }
`;

export const ValueContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
`;

export const ValueLabel = styled.span`
    font-size: 0.75rem;
    font-weight: 400;
    color: ${GREY_300};
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 0.25rem;

`;

export const Value = styled.span`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${color('text.main')};
`;

export const SalesRatioRoot = styled.span`
    display: inline-flex;
    flex-wrap: nowrap;
    align-items: baseline;
    column-gap: 0.25rem;
`;

export const SalesRatioFigure = styled.span`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${color('text.main')};
`;

export const SalesRatioMuted = styled.span`
    font-size: 0.8125rem;
    font-weight: 400;
    color: ${GREY_300};
`;

export const ChangeContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 0.5rem;
    border-left: 1px solid ${color('border.divider')};
`;
